import React, { useState, useEffect } from "react";
import { isEmpty } from "../libs/isEmpty";
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import DeleteIcon from '@material-ui/icons/Delete';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ModalButton from './ModalButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import EditIcon from '@material-ui/icons/Edit';
import SyncIcon from '@material-ui/icons/Sync';
import { FormHelperText, Grid, Tooltip } from "@material-ui/core";
import { trimString } from "../libs/trimString";
import Button from '@material-ui/core/Button';
import WarningIcon from '@material-ui/icons/Warning';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import VisibilityIcon from '@material-ui/icons/Visibility';
import FileUpload from './FileUpload';
import { orange } from '@material-ui/core/colors';
import { useCardStyles } from '../styles/commonStyles';

export default function InteresseOmraadeList({
  ...props
}) {
  const classes = useCardStyles();
  const [isVendorless, setIsVendorless] = useState(true);

  useEffect(() => {
    if (isEmpty(props.vendorMeta)) {
      setIsVendorless(true)
    } else {
      setIsVendorless(false)
    }
  }, [props.vendorMeta])

  const rows = props.omraader

  function setOmraade(interesseomraade){
    props.set(interesseomraade)
  }

  function renderGeomWarning(geom, interesse_ft) {
    if (interesse_ft && interesse_ft !== '') {
      return (
        <Tooltip title="Geometrien styres fra en ekstern kilde (featuretype)">
          <SyncIcon color="primary" />
        </Tooltip>
      )
    } else if (!geom || geom === null || geom === '' || geom.length === 0) {
      return (
        <Tooltip title="Interesseområdet har ingen geografisk afgrænsning defineret">
          <WarningIcon style={{ color: orange[500] }} />
        </Tooltip>
      )
    } else {
      return (
        <Tooltip title="Interesseområdet har geografisk afgrænsning">
          <CheckCircleIcon style={{ color: 'green' }} />
        </Tooltip>
      )
    }
  }

  function renderPaavisningIcon(paavisning) {
    if (paavisning) {
      return (
        <Tooltip title="Påvisning er påkrævet">
          <VisibilityIcon color="primary" />
        </Tooltip>
      )
    }
    return null;
  }

  return (
    <Card
      className={classes.root}
      raised
    >
      <CardHeader title="Interesseområder" />
      <CardContent>
          {isVendorless ? (
            <>
            <ListItem className={classes.listitem} key={"addInteresseOmraade"}>
              <ListItemText>
               Der er ikke valgt en profil.
              </ ListItemText>
            </ListItem>        
            </>
          ) : (
            <>
            <Table size="small" className={classes.table} aria-label="interesseomraade-table">
              <TableHead>
                <TableRow>
                  <TableCell>Interesseområde</TableCell>
                  <TableCell align="center">Geometri</TableCell>
                  <TableCell align="center">Påvisning</TableCell>
                  <TableCell align="center">Handlinger</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map(row => (
                  <TableRow key={row.interesseomraade}>
                    <TableCell component="th" scope="row">{trimString(row.interesseomraade, 40)}</TableCell>
                    <TableCell align="center">{renderGeomWarning(row.geom, row.interesse_ft)}</TableCell>
                    <TableCell align="center">{renderPaavisningIcon(row.paavisning)}</TableCell>
                    <TableCell align="center">
                    <Grid 
                      container
                      direction="row"
                      alignItems="flex-start"
                      justifyContent="center">
                        <Grid item>
                          <Button
                          onClick={() => setOmraade(row.interesseomraade)}>
                            <EditIcon />
                          </Button>
                        </Grid>
                        <Grid item>
                          <ModalButton
                            btnColor="default"
                            id={row.interesseomraade}
                            btnText={<DeleteIcon />}
                            acceptAction={() => {props.delete(row.interesseomraade)}}
                            acceptText="slet"
                            cancelText="fortryd"
                            titleText={"Bekræft sletning af interesseområde: " + row.interesseomraade}
                            contentText={"Denne handling fjerner interesseområdet: '" + row.interesseomraade + "' tilhørende " + props.vendorMeta.vendor_alias + " uden yderligere varsel. Der vil ikke blive dannet svar for forespørgsler i dette interesseområde. Interesseområdet bliver kun fjernet i dette system, der sendes ikke ændringer til LER"}
                          />         
                        </Grid>
                      </Grid>
                    </TableCell>
                  </TableRow>
                ))}
                <TableRow key="add-new">
                  <TableCell colSpan={4}>
                    <FormHelperText>Tilføj nyt interesseområde ved at uploade en GML-fil fra LER. Området skal først oprettes på LER-platformen. Uploades en fil til allerede eksisterende område, vil dette område bliver slette først - derefter lagt ind igen.</FormHelperText>
                    <FileUpload
                      accept={['application/gml+xml', '.gml']}
                      onSuccess={(response, values) => {
                        let body = {
                          doc_id: response.data.doc_id
                        }
                        props.create({body});
                      }}
                    />
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
            </>
          )}
      </CardContent>
    </Card>
  )
}